import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostArea2025/layout/Component/FormTitle';
import FormWaring from '@src/mobile/phtvHostArea2025/layout/Component/FormWaring';
import UploadVideo from './UploadVideo';
import UploadPic from './UploadPic';
import { area } from '@src/utils/area';

const Media = ({ formData, setFormDataHandle, warningTextList, updateId, updateSuccess, languages }) => {
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.media}>
            {/* 形象照片 */}
            <FormTitle name="img" title={area[languages].photo.title} warningText={warningTextList['img']} isRequired={true} />
            <div className={styles.picInfo} dangerouslySetInnerHTML={{ __html: area[languages].photo.placeholder }} />
            <div className={styles.picList}>
                <UploadPic name="img1" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} languages={languages} />
                <UploadPic name="img2" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} languages={languages} />
                <UploadPic name="img3" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} languages={languages} />
            </div>
            <FormWaring warningText={warningTextList['img']} />
            {/* 自我介绍视频 */}
            <FormTitle name="video1" title={area[languages].video1.title} warningText={warningTextList['video1']} isRequired={true} />
            <div className={styles.picInfo} dangerouslySetInnerHTML={{ __html: area[languages].video1.placeholder }} />
            <UploadVideo name="video1" formData={formData} changeInputHandle={changeInputHandle} languages={languages} />
            <FormWaring warningText={warningTextList['video1']} />
        </div>
    );
};

Media.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool,
    languages: PropTypes.string,
};

export default errorBoundary(Media);
